import api from '@/services/api';

// ディスプレイ情報の保存
export const userMetaLog = {
  strict: process.env.NODE_ENV === 'local',
  namespaced: true,
  actions: {
    createUserMetaLog({ commit }, payload) {
      const postData = {
        email: payload.email,
        api_name: payload.api_name,
        user_agent: window.navigator.userAgent.toLowerCase(),
        window_height: window.screen.height,
        window_width: window.screen.width,
        path: location.pathname
      };
      api.post('save_display_info/', postData);
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/user_meta_log.js